<!--
#########################################################################################
######    Vista SVC95000  :  Formulario Pago TPV (CECA) - Página OK/Error   (2/3)  ######
#########################################################################################
-->

<template>
<div>
  
  <TNC10000></TNC10000>
  <br/><br/><br/>
  <div class="igs-center">
    <!--
    <h2  class="igs-h3 igs-color2"                        v-if="lnCodigoError == -1" >Comprobando ...</h2>
    <h2  class="igs-h3"             style="color:#009900" v-if="lnCodigoError == 0"  >Éxito<br/>Operación Aprobada</h2>
    <h2  class="igs-h3"             style="color:#ff0000" v-if="lnCodigoError >  0"  >Error</h2>
    -->
    <!--
    <img :src="f99ImageName('ih1-reloj-arena-gris')"    height="96" v-if="lnCodigoError == -1"> 
    <img :src="f99ImageName('ih1-ok-azul')"             height="96" v-if="lnCodigoError ==  0"> 
    <img :src="f99ImageName('ih1-error-rojo')"          height="96" v-if="lnCodigoError >   0"> 
    -->

    <br/><br/><br/>

    <div class="row">  
      <div class="col-12 igs-h4 igs-center">  
        <img :src="f99ImageNameGIF('ic1-reloj-arena')"          height="128" /> 
      </div>
    </div>

  </div>

  <br/>
  
  <!--
  <h3 style="color:#ff0000">{{ltMensajeError}}</h3>
  -->

    <div id="t097m001" style="display:none">
    { 
        "t097m001" : {
            "tkey" : "95010",
            "tmsg" : "{{ltMensajeError}}",
            "t901" : "{{ltReferenciaPedido}}",
            "t902" : "{{ltCodigoError}}",
            "t903" : "{{ltCodigoTienda}}",
            "t904" : "{{ltCodigoTerminal}}",
            "t905" : "{{ltTipoTransaccion}}",
            "t906" : "{{ltCodigoAutorizacion}}",
            "t907" : "{{ltFechaAutorizacion}}",
            "t908" : "{{ltHoraAutorizacion}}",
            "t909" : "{{ltTipoTarjeta}}",
            "t910" : "{{ltPaisTarjeta}}",
            "t911" : "{{ltMonedaOperacion}}",
            "t912" : "{{ltImporteOperacion}}",
            "t913" : "{{ltReferenciaERP}}",
            "t914" : "{{ltPagoSeguro}}",
            "t915" : "{{ltPANTarjeta}}",
            "t916" : "{{ltCaducidadTarjeta}}",
            "t917" : "{{ltIdentificadorTarjeta}}",
            "t918" : "{{ltIdiomaUsuario}}"
        }
    }
    </div>

  
  <BNC10000></BNC10000>

</div>
</template>

<script>
import igs_mixin from '@/igs-mixins/igs_mixin'
const  axios = require("axios")

import TNC10000  from '@/igs-navegacion/TNC10000'
import BNC10000  from '@/igs-navegacion/BNC10000'

export default {
  mixins: [ igs_mixin ],
  components : { TNC10000, BNC10000 },

  //=======================================================================
  //------------------------ Variables Locales  ---------------------------
  //=======================================================================
  data() {
    return {
        lnCodigoError :         -1,
        ltMensajeError :        '',

        ltReferenciaPedido:     '',
        ltCodigoError:          '',
        ltTipoTarjeta:          '',
        ltCodigoTienda:         '',
        ltCodigoTerminal:       '',
        ltTipoTransaccion:      '',
        ltCodigoAutorizacion:   '',
        ltFechaAutorizacion:    '',
        ltHoraAutorizacion:     '',
        ltPaisTarjeta:          '',
        ltMonedaOperacion:      '',
        ltImporteOperacion:     '',
        ltReferenciaERP:        '',
        ltPagoSeguro:           '',
        ltPANTarjeta:           '',
        ltCaducidadTarjeta:     '',
        ltIdentificadorTarjeta: '',
        ltIdiomaUsuario:        ''

    }
  },

  //=======================================================================
  //------------------------ Variables Calculadas  ---------------------------
  //=======================================================================
  computed : {

    //-----------------------------------------------
    //-- Dirección Completa de la Página Actual
    //-----------------------------------------------
    lt91URLCompleta() {
      return window.location.href;
    }

  },

  beforeRouteUpdate(to, from, next) {
      /*
        Cualquier código a ejecutar ANTES del cambio de URL
      */

      //-- Permiso para proseguir
      next();
  },

  //=======================================================================
  //------------------------ Métodos Locales  ---------------------------
  //=======================================================================
  methods: {


    //--------------------------------------------------------------------------------
    //-- Comprobación del Contenido Recibido
    //--------------------------------------------------------------------------------
    lp50ComprobarRespuesta() {

      //-- Obtener la URL Completa
      var URL = this.lt91URLCompleta;

      //-- Determinar el número de fragmentos (parámetros) que vienen cargados
      var parametros = URL.split("/");

      //----------------------------------------------------------
      //-- Examinar la Respuesta Recibida
      //----------------------------------------------------------
      //console.log('-- Inicio Análisis de la Respuesta  --');

      //-- Extraer valores a utilizar en este Método
      var indiceTPV             = this.$store.state.strT001M030_Indice;  // Valores : 1, 2, ..., n

      //----- TEMPORAL (Pruebas) ----
      // indiceTPV = 2;
      //-----------------------------

      if (indiceTPV > 0) { indiceTPV = indiceTPV - 1; }                  // Aplicar : 0, 1, ..., n-1


      //-- Comunicar con el Servidor iHoreca para conocer la Aprobación/Denegación del Pago para esta "Referencia Pedido"
      var ih1URL = this.f97GetURL('230', '915') + '&x=' + this.$store.state.strReferenciaPedido;
      
      //-- Solicitud de Datos al Servidor 
      axios.get(ih1URL, {responseEncoding: 'utf-8'}).then(respuesta => {
        //console.info('-- Obteniendo Respuesta del Distribuidor  --');
        //console.log(' Respuesta :')
        //console.log(respuesta.data);

        //-- Extraer la respuesta recibida
        var datos = respuesta.data;
        var flg = global.lnkGetDataError;
        if (datos.flg) {  flg = datos.flg; }

        //-- Actualizar Resultados
        if (flg == global.lnkGetDataOk) {
          //console.log('¡¡¡¡¡¡ Exito !!!!!!');

          //-- Actualizar la Imagen
          this.lnCodigoError = 0;

          //-- Cargar Valores
          this.ltReferenciaPedido     = this.$store.state.strReferenciaPedido;
          this.ltCodigoError          = datos.t230m915.p094;
          this.ltCodigoTienda         = this.$store.state.strT001M030[indiceTPV].codigoComercio;
          this.ltCodigoTerminal       = this.$store.state.strT001M030[indiceTPV].terminalComercio;
          this.ltTipoTransaccion      = '001';
          this.ltCodigoAutorizacion   = datos.t230m915.p095;
          this.ltFechaAutorizacion    = datos.t230m915.p053.substr(0,4)+'-'+datos.t230m915.p053.substr(4,2)+'-'+datos.t230m915.p053.substr(6,2);
          this.ltHoraAutorizacion     = datos.t230m915.p054.substr(0,2)+':'+datos.t230m915.p054.substr(2,2);
          this.ltTipoTarjeta          = '1';
          this.ltPaisTarjeta          = 'ES';
          this.ltMonedaOperacion      = '978';
          this.ltImporteOperacion     = parametros[10];
          this.ltReferenciaERP        = parametros[9];

          this.ltPagoSeguro           = '0';
          this.ltPANTarjeta           = '';
          this.ltCaducidadTarjeta     = '';
          this.ltIdentificadorTarjeta = '';
          this.ltIdiomaUsuario        = '1';

          //-- Determinar si retrasar la transición (a fin de mostrar el mensaje de error)
          var pausa = 2000;               //-- Pausa en caso OK     =  2 Segundos
        
          if        (this.lnCodigoError == 0) {
            this.ltMensajeError = "";
          } else if (this.lnCodigoError > 0) {
            pausa = 10000;                //-- Pausa en caso ERROR  = 10 Segundos

            this.ltMensajeError = "(eTPV "+this.lnCodigoError+") "+this.ltMensajeError;
          }


              
          //***************************************************************************/
          //*********** EXITO en la ACTUALIZACIÓN SOBRE EL SERVIDOR REMOTO  ***********/
          //***************************************************************************/
          //-- Redirigir a la Página FINAL (99000), a fin de mostrar el RESUMEN de la Operación
          if (this.lnCodigoError == 0) {

                //-- (a) URLs del Panel : Desarrollo ó Producción
                var URLPanel  = 'http://' + window.location.hostname + ':8080';
                if (window.location.hostname == "panel.ihoreca.es") { URLPanel  = "https://panel.ihoreca.es"; }

                //-- Pantalla Final (con Resumen de la Operación)
                var targetURL = URLPanel + '/99010/' + 
                            this.$store.state.strDistribuidor       + '/' + 
                            this.$store.state.strUsuario            + '/' + 
                            this.$store.state.strIDSesion           + '/' + 
                            this.$store.state.strCliente            + '/' + 
                            this.$store.state.strNifClienteOfuscado + '/' +
                            this.$store.state.strReferenciaPedido   + '/' + 
                            this.ltImporteOperacion                 + '/' +
                            
                            encodeURIComponent(
                            this.ltCodigoError          + '|' + this.ltCodigoTienda       + '|' + this.ltCodigoTerminal     + '|' + 
                            this.ltTipoTransaccion      + '|' + this.ltCodigoAutorizacion + '|' + this.ltFechaAutorizacion  + '|' + 
                            this.ltHoraAutorizacion     + '|' + this.ltTipoTarjeta        + '|' + this.ltPaisTarjeta        + '|' + 
                            this.ltMonedaOperacion      + '|' + this.ltImporteOperacion   + '|' + this.ltReferenciaERP      + '|' +
                            this.ltPagoSeguro           + '|' + this.ltPANTarjeta         + '|' + this.ltCaducidadTarjeta   + '|' +
                            this.ltIdentificadorTarjeta + '|' + this.ltIdiomaUsuario);

                //console.log('Pausa : '+pausa);
                setTimeout(() =>  window.location.href = targetURL, pausa);

          }

          
        } else {
          this.lnCodigoError = 9999;
          this.ltMensajeError = "(E9999) "+datos.msg;
        }

      }).catch(error => {
        console.info('Error : '+error);
        this.lnCodigoError = 9998;
        this.ltMensajeError = "(E9998) "+error.message;
      });

      
    },

    //------------------------------------------------------
    //-- Reclamar Lista de TPV Virtuales disponibles
    //------------------------------------------------------
    lp98t001m030() {
      
      var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&d="+this.$store.state.strDistribuidor+"&u="+this.$store.state.strUsuario+"&t=001&m=030";
      //console.log(URL);

      //-- Mostrar el/los indicadores de actividad oportunos
      this.$store.commit('p10StrRecibiendoDatos', true);
        
      //-- Solicitud de Datos al Servidor 
      axios.get(URL, {responseEncoding: 'utf-8'})
      .then(respuesta => {
      
            //console.log('Respuesta : ');
            //console.log(respuesta.data);

            //-- Desactivar los Indicadores de Actividad
            this.$store.commit('p10StrRecibiendoDatos', false);

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si el contenido es el correcto
            if (datos.t001m030) {
              //-- Debug
              //console.log('-- Lista de TPVs OK --');
              //console.log('** Array **');
              //console.dir(datos.t001m030);
              //console.log('** Índice **');
              //console.dir(datos.t001m030_indice);
              //console.log('----------------------');
              
              //-- Actualizar Información relacionada con los TPVs
              this.$store.commit('p10StrT001M030',        datos.t001m030);
              this.$store.commit('p10StrT001M030_Indice', datos.t001m030_indice);

              //var i = this.$store.state.strT001M030_Indice;
              //console.log(' (A) Índice = '+i);


              //-- Comprobar la Autorización para el PAGO
              this.lp50ComprobarRespuesta();
            } else {
                this.p99AnuncioIH1('2','7','ERROR', 'Error (TPV01)',-1);
            }
                
        })
        .catch(error => {
          //-- Desactivar los Indicadores de Actividad
          this.$store.commit('p10StrRecibiendoDatos', false);

          //-- Mostrar el Mensaje de Error oportuno
          this.p99AnuncioIH1('2','7','ERROR', error.message,-1);
        });

    }



  },

  //=======================================================================
  //------------ Métodos a aplicar una vez CARGADA la Página  -------------
  //=======================================================================
  mounted() {
    //-- Mensajes
    //console.log('SVC mounted');

    //-- Comprobar la Respuesta Recibida
    this.lp98t001m030();

  }
}
</script>

<style type="scope">
</style>
